import swal from 'sweetalert2';

export const handleApiError = async (error, options = {}) => {
    const {
        showAlert = true,
        customTitle = 'Erro',
        customIcon = 'error',
        onClose = null
    } = options;

    let errorMessage = 'Ocorreu um erro inesperado';

    if (typeof error === 'string') {
        errorMessage = error;
    } else if (error?.error) {
        errorMessage = error.error;
    } else if (error?.message) {
        errorMessage = error.message;
    }

    const isEmptyData = error?.isEmpty === true;
    const icon = isEmptyData ? 'info' : customIcon;
    const title = isEmptyData ? 'Atenção' : customTitle;

    if (showAlert) {
        await swal.fire({
            title,
            text: errorMessage,
            icon,
            confirmButtonText: 'OK',
            customClass: {
                confirmButton: 'btn btn-primary'
            },
            buttonsStyling: false
        });

        if (onClose) {
            onClose();
        }
    }

    return {
        handled: true,
        message: errorMessage,
        isEmpty: isEmptyData
    };
};

export const safeDispatch = async (store, action, payload, errorOptions = {}) => {
    try {
        const result = await store.dispatch(action, payload);
        
        if (result && !result.status && result.error) {
            await handleApiError(result, errorOptions);
            return null;
        }
        
        return result;
    } catch (error) {
        await handleApiError(error, errorOptions);
        return null;
    }
};

export const setupGlobalErrorHandler = (app) => {
    app.config.errorHandler = (err, instance, info) => {
        console.error('Global error:', err);
        console.error('Error info:', info);
        
        if (err?.handled) {
            return;
        }

        if (process.env.NODE_ENV === 'development') {
            console.error('Component:', instance);
        }
    };

    window.addEventListener('unhandledrejection', (event) => {
        event.preventDefault();
        
        if (event.reason?.handled || event.reason?.intercepted) {
            return;
        }

        console.error('Unhandled promise rejection:', event.reason);
    });
};
